import React from "react";
import "./css/service.css";
import { Helmet } from "react-helmet";

import ServiceSection1 from "./subpages/services/service1";
import ServiceSection2 from "./subpages/services/service2";
import ServiceSection3 from "./subpages/services/service3";
import Footer from "../footer";

//import { Container, Row, Col } from "react-bootstrap";

const Service = () => {
  return (
    <div className="container-fluid px-0">
      <Helmet>
        <title>Servicio Voila</title>
        <meta name="description" content="Description of your page for SEO" />
      </Helmet>
       <ServiceSection1 />
       <ServiceSection2 />
       <ServiceSection3 />
       <Footer isScrollable={false} />
    </div>
  );
};

export default Service;
